import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useAuthorizedAxios } from '../../../core/hooks';
import { defaultPaginationSettings, PaginationViewModel } from '../../../core/model';
import { isValidCustomerId } from '../../../customers';
import { getItsmMaintenanceWorks } from '../../api';
import { ItsmHttpQueryConfig } from '../../config';
import { ItsmMaintenanceWorkViewModel } from '../../model';

interface ItsmMaintenanceWorksApiGetHookResult {
  maintenanceWorks: ItsmMaintenanceWorkViewModel[];
  total: number;
  isFetching: boolean;
  isFetched: boolean;
  pagination: PaginationViewModel;
  setPagination: (pagination: PaginationViewModel) => void;
}

export const useItsmMaintenanceWorks = (customerId: number | null): ItsmMaintenanceWorksApiGetHookResult => {
  const axios = useAuthorizedAxios();
  const [pagination, setPagination] = useState<PaginationViewModel>(defaultPaginationSettings());
  const { data, isFetched, isFetching } = useQuery({
    queryKey: [ItsmHttpQueryConfig['GetItsmMaintenanceWorks'].key, customerId, pagination],
    queryFn: async () => {
      if (customerId === null) {
        return null;
      } else {
        return await getItsmMaintenanceWorks(axios, { customerId, pagination });
      }
    },
    enabled: isValidCustomerId(customerId),
    gcTime: 30000,
    staleTime: 1000,
    structuralSharing: false,
  });
  const response = data || { total: 0, data: [] };
  return {
    maintenanceWorks: response?.data,
    total: response?.total,
    isFetched,
    isFetching,
    pagination,
    setPagination
  };
};